export const navigation = {
  it: {
    home: "Home",
    about: "Chi Sono",
    solutions: "Servizi",
    blog: "Blog",
    testimonials: "Testimonianze",
    contact: "Contatti",
    demo: "Demo",
    legal: {
      terms: "Termini",
      privacy: "Privacy",
      cookies: "Cookie"
    }
  },
  en: {
    home: "Home",
    about: "About",
    solutions: "Services",
    blog: "Blog",
    testimonials: "Testimonials",
    contact: "Contact",
    demo: "Demo",
    legal: {
      terms: "Terms",
      privacy: "Privacy",
      cookies: "Cookies"
    }
  }
}; 